import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

import makeApiRequest from "../../utils/axios/new-axios";
import { LOCATION_CATEGORY_EDIT_URL } from "../../config";
import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";
import { showSuccessAlert, showErrorAlert } from "../../store/actions/alerts";

import LocCategorySelector from "../formik/LocCategorySelector";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
  },
}));

export default function CategoriesForm({
  openModal,
  handleCloseModal,
  initialValues,
  locationId,
  setSelectedCategory,
}) {
  const dispatch = useDispatch();

  const classes = useStyles();

  async function handleSubmit(values, { setSubmitting }) {
    setSubmitting(true);

    await makeApiRequest({
      url: `${LOCATION_CATEGORY_EDIT_URL.url}/${locationId}`,
      method: LOCATION_CATEGORY_EDIT_URL.method,
      data: values.category,
    })
      .then((response) => {
        dispatch(showSuccessAlert(`Updated Successfully!`));
        setSelectedCategory(response.data.category);
        handleCloseModal();
      })
      .catch((error) => {
        dispatch(
          showErrorAlert(
            "Error : " +
            (!!error.response
              ? `${error.response.status}! - ${error.response.data.errorMessage}`
              : error.message)
          )
        );
      });

    setSubmitting(false);
  }

  return (
    <Dialog
      open={openModal}
      onClose={handleCloseModal}
      fullWidth={true}
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      disableEnforceFocus={true}
    >
      <DialogTitle id="alert-dialog-title">
        Edit Location Categories
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          category: Yup.array().of(Yup.number().required()).required(),
        })}
      >
        {(props) => {
          const { touched, errors, isSubmitting } = props;
          return (
            <Form className={classes.form}>
              <DialogContent dividers /*style={{ overflow: "visible" }}*/>
                <Field
                  name="category"
                  component={LocCategorySelector}
                  label="Categories"
                  helperText={
                    touched.category && errors.category && errors.category
                  }
                  error={!!touched.category && !!errors.category}
                  disabled={isSubmitting}
                />
              </DialogContent>
              <DialogActions style={{ margin: "20px" }}>
                <CancelButton
                  onClick={handleCloseModal}
                  disabled={isSubmitting}
                >
                  Cancel
                </CancelButton>
                <SubmitButton
                  disabled={isSubmitting}
                  isSubmitting={isSubmitting}
                  autoFocus
                >
                  Update
                </SubmitButton>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}
